/**
 * 考试试卷中心
 */

import {
    get,
    post,
    put,
    del
} from '@/util/request'
import download from "@/util/download";

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectExamResultById = (Id) => {
    return get('/api/app/ExamResult?CurrentId=' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddExamResult = (data) => {
    return post('/api/app/ExamResult', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyExamResult = (data) => {
    return put('/api/app/ExamResult', data, {});
}

/**
 * 分页获取
 * @param {*} data
 * @returns
 */
export const GetDataExamResultList = (data) => {
    return post('/api/app/ExamResult/list', data, {});
}


/**
 * 链表分页获取
 * @param {*} data
 * @returns
 */
export const GetDataExamResultListByPageQuery = (data) => {
    return post('/api/app/ExamResult/getDataByPageQuery', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteExamResult = (id) => {
    return del('/api/app/ExamResult/' + id, {}, {});
}

/**
 * 试卷编辑
 * @param {*} data
 * @returns
 */
 export const ModifyExamResultData = (data) => {
    return post('/api/app/ExamResult/modifyExamResult', data, {});
}

/**
 * 试卷新增
 * @param {*} data
 * @returns
 */
 export const AddExamResultData = (data) => {
    return post('/api/app/ExamResult/ExamResult', data, {});
}

/**
 * 试卷发布
 * @param {*} id  试卷id
 * @param {*} publishId  发布人,当前登录用户
 * @returns
 */
 export const PublishExamResult = (id,publishId) => {
    return post('/api/app/ExamResult/'+id+'/publishExamResult/'+publishId);
}

/**
 * 4.通过Id获取考试试卷的详细信息
 * @param {*} Id
 * @returns
 */
export const GetExamResultInfoById = (Id) => {
    return get('/api/app/examResult/myExamResultDetail/'+Id+'?justLookWrong=false');
}

/**
 * 5.考试数据中心链表分页查询
 * @param {*}
 * @returns
 */
 export const GetExamResultDataByPageQuery = (param) => {
    return post('/api/app/examResult/getExamResultDataByPageQuery',param);
}

/**
 * 6.考试数据中心考试明细统计
 * @param {*} examId
 * @returns
 */
 export const GgetExamResultDetail = (examId) => {
    return post('/api/app/examResult/getExamResultDetail/'+examId);
}

/**
 * 导出Excel
 * @param {*} id
 * @returns
 */
 export const ExportExamResult = (data,title) => {
    let defaluturl = `/api/app/examResult/exportExcelFile`;
    let fileName = "考试成绩报告"
    if(title) {
      fileName = title;
    }
    return download(fileName, defaluturl, data);
  }

